export enum ETagImportStep {
  TAG_LIST = 'tagList',
  FILE = 'file',
  SITES = 'sites',
}
